import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useReceiptsList() {
  // Use toast
  const toast = useToast();

  const refReceiptListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "id", label: "收據編號", class: 'sticky-column', sortable: true },
    { key: "receipt_date", label: "收據日期", class: 'sticky-column', sortable: true },
    { key: "actions", label: "操作", class: 'sticky-column' },
    { key: "show_details", label: "支付項目" },
    { key: "stamp", label: "印章" },
    { key: "customer.name_cn", label: "單據抬頭" },
    /*     { key: "quotation_id", label: "發票編號", sortable: true }, */
    // { key: "project.project_number", label: '項目編號' },
    // { key: "project_name", label: "項目名稱", sortable: true },
    { key: "address", label: "施工地址", sortable: true },
    { key: "payment_method.name", label: "收款方式" },
    { key: "amount", label: "金額", sortable: true, formatter: formatCurrency },
    { key: 'total_refund', label: '已退款金額', formatter: formatCurrency },
    /*     { key: "name_cn", label: "單據抬頭" },
        { key: "name_en", label: "單據抬頭" },
        { key: "mobile", label: "聯絡電話" },
        { key: "email", label: "電郵地址"}, */
    /*     { key: "pay_date", label: "收款日期", sortable: true }, */
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("receipt_date");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refReceiptListTable.value
      ? refReceiptListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refReceiptListTable.value.refresh();
  };

  const receiptsList = ref(null);

  const filter_customer_id = ref(null);
  const filter_project_id = ref(null);
  const filter_invoice_id = ref(null);
  const filter_payment_method_id = ref(null);
  const filter_start_date = ref(null);
  const filter_end_date = ref(null);
  const filter_min_amount = ref(0);
  const filter_max_amount = ref(1000000);

  watch(
    [currentPage, perPage, searchQuery, 
      filter_invoice_id,
      filter_customer_id, 
      filter_project_id, 
      filter_payment_method_id, 
      filter_customer_id,
      filter_project_id,
      filter_payment_method_id,
      filter_start_date,
      filter_end_date,
      filter_min_amount,
      filter_max_amount,
    ],
    () => {
      refetchData();
    }
  );

  const fetchReceipts = (ctx, callback) => {
    store
      .dispatch("receipt/fetchReceipts", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        invoice_id: filter_invoice_id.value,
        project_id: filter_project_id.value,
        customer_id: filter_customer_id.value,
        payment_method_id: filter_payment_method_id.value,
        start_date: filter_start_date.value,
        end_date: filter_end_date.value,
        min_amount: filter_min_amount.value,
        max_amount: filter_max_amount.value,
      })
      .then((response) => {
        const { receipts, total } = response.data;
        callback(receipts);
        totalRow.value = total;
        receiptsList.value = receipts
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const invoiceOptions = ref([]);
  const customerOptions = ref([]);
  const projectOptions = ref([]);
  const paymentMethodOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        invoices: true,
        customers: true,
        projects: true,
        receive_methods: true,
      })
      .then((response) => {
        invoiceOptions.value = response.data.invoices;
        customerOptions.value = response.data.customers;
        projectOptions.value = response.data.projects;
        paymentMethodOptions.value = response.data.receive_methods.sort ((a, b) => a.sort_order - b.sort_order);
      });
  };


  onMounted(() => {
    refetchData();
    refetchOption();
  });

  return {
    fetchReceipts,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    receiptsList,
    refReceiptListTable,
    ability,
    refetchData,
    filter_invoice_id,
    filter_project_id,
    filter_customer_id,
    filter_payment_method_id,
    filter_start_date,
    filter_end_date,
    filter_min_amount,
    filter_max_amount,
    invoiceOptions,
    customerOptions,
    projectOptions,
    paymentMethodOptions,
  };
}
